import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Breadcrumbs,
  Link as MuiLink,
  Fade,
  Slide,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Business as BusinessIcon,
  TrendingUp as TrendingUpIcon,
  Analytics as AnalyticsIcon,
  Support as SupportIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Group as GroupIcon,
  LocalShipping as LocalShippingIcon,
  Payment as PaymentIcon,
  Inventory as InventoryIcon,
  Campaign as CampaignIcon,
  Star as StarIcon,
  CheckCircle as CheckCircleIcon,
  Close as CloseIcon,
  Upload as UploadIcon,
  ContactSupport as ContactSupportIcon,
  AccountBalance as AccountBalanceIcon,
  Store as StoreIcon,
  Factory as FactoryIcon,
  Agriculture as AgricultureIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BusinessAccount = () => {
  const [registrationOpen, setRegistrationOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    businessName: '',
    businessType: '',
    contactPerson: '',
    email: '',
    phone: '',
    address: '',
    tradeLicense: '',
    tinNumber: '',
    bankAccount: '',
    accountType: 'standard'
  });

  const businessBenefits = [
    {
      icon: <TrendingUpIcon />,
      title: 'বিক্রয় বৃদ্ধি',
      description: 'অনলাইন প্ল্যাটফর্মে আপনার ব্যবসা সম্প্রসারণ করুন',
      color: '#4CAF50'
    },
    {
      icon: <AnalyticsIcon />,
      title: 'বিক্রয় বিশ্লেষণ',
      description: 'বিস্তারিত রিপোর্ট ও বিশ্লেষণের মাধ্যমে ব্যবসা পরিচালনা',
      color: '#2196F3'
    },
    {
      icon: <SupportIcon />,
      title: 'ডেডিকেটেড সাপোর্ট',
      description: 'ব্যবসায়িক গ্রাহকদের জন্য বিশেষ কাস্টমার সাপোর্ট',
      color: '#FF9800'
    },
    {
      icon: <SecurityIcon />,
      title: 'নিরাপদ লেনদেন',
      description: 'উন্নত নিরাপত্তা ব্যবস্থা ও দ্রুত পেমেন্ট',
      color: '#9C27B0'
    },
    {
      icon: <SpeedIcon />,
      title: 'দ্রুত ডেলিভারি',
      description: 'অগ্রাধিকার ভিত্তিক ডেলিভারি সেবা',
      color: '#F44336'
    },
    {
      icon: <GroupIcon />,
      title: 'বাল্ক অর্ডার',
      description: 'বড় পরিমাণ অর্ডারের জন্য বিশেষ ছাড়',
      color: '#607D8B'
    }
  ];

  const accountTypes = [
    {
      type: 'স্ট্যান্ডার্ড',
      price: 'বিনামূল্যে',
      features: [
        'মাসিক ১০০০ পণ্য লিস্টিং',
        'বেসিক অ্যানালিটিক্স',
        'ইমেইল সাপোর্ট',
        '৫% কমিশন',
        'স্ট্যান্ডার্ড ডেলিভারি'
      ],
      recommended: false,
      color: '#607D8B'
    },
    {
      type: 'প্রিমিয়াম',
      price: '৫,০০০ টাকা/মাস',
      features: [
        'আনলিমিটেড পণ্য লিস্টিং',
        'অ্যাডভান্সড অ্যানালিটিক্স',
        'ফোন ও চ্যাট সাপোর্ট',
        '৩% কমিশন',
        'প্রায়োরিটি ডেলিভারি',
        'মার্কেটিং টুলস'
      ],
      recommended: true,
      color: '#2196F3'
    },
    {
      type: 'এন্টারপ্রাইজ',
      price: 'কাস্টম প্রাইসিং',
      features: [
        'আনলিমিটেড সব ফিচার',
        'ডেডিকেটেড অ্যাকাউন্ট ম্যানেজার',
        '২৪/৭ সাপোর্ট',
        '১% কমিশন',
        'এক্সপ্রেস ডেলিভারি',
        'কাস্টম ইন্টিগ্রেশন',
        'API অ্যাক্সেস'
      ],
      recommended: false,
      color: '#9C27B0'
    }
  ];

  const businessTypes = [
    { value: 'retail', label: 'খুচরা ব্যবসা', icon: <StoreIcon /> },
    { value: 'wholesale', label: 'পাইকারি ব্যবসা', icon: <FactoryIcon /> },
    { value: 'agriculture', label: 'কৃষি ব্যবসা', icon: <AgricultureIcon /> },
    { value: 'manufacturing', label: 'উৎপাদন ব্যবসা', icon: <FactoryIcon /> },
    { value: 'service', label: 'সেবা প্রদানকারী', icon: <SupportIcon /> },
    { value: 'other', label: 'অন্যান্য', icon: <BusinessIcon /> }
  ];

  const features = [
    {
      category: 'পণ্য ব্যবস্থাপনা',
      items: [
        'বাল্ক পণ্য আপলোড',
        'ইনভেন্টরি ট্র্যাকিং',
        'অটো স্টক আপডেট',
        'পণ্য ক্যাটালগ ম্যানেজমেন্ট'
      ],
      icon: <InventoryIcon />
    },
    {
      category: 'অর্ডার ম্যানেজমেন্ট',
      items: [
        'রিয়েল-টাইম অর্ডার ট্র্যাকিং',
        'অটো অর্ডার প্রসেসিং',
        'বাল্ক অর্ডার হ্যান্ডলিং',
        'রিটার্ন ম্যানেজমেন্ট'
      ],
      icon: <LocalShippingIcon />
    },
    {
      category: 'পেমেন্ট সিস্টেম',
      items: [
        'মাল্টিপল পেমেন্ট গেটওয়ে',
        'দ্রুত সেটেলমেন্ট',
        'অটো ইনভয়েস জেনারেশন',
        'ট্যাক্স ক্যালকুলেশন'
      ],
      icon: <PaymentIcon />
    },
    {
      category: 'মার্কেটিং টুলস',
      items: [
        'প্রমোশনাল ক্যাম্পেইন',
        'ডিসকাউন্ট ম্যানেজমেন্ট',
        'কাস্টমার সেগমেন্টেশন',
        'ইমেইল মার্কেটিং'
      ],
      icon: <CampaignIcon />
    }
  ];

  const registrationSteps = [
    {
      title: 'ব্যবসায়িক তথ্য',
      description: 'আপনার ব্যবসার মূল তথ্য প্রদান করুন'
    },
    {
      title: 'যোগাযোগের তথ্য',
      description: 'যোগাযোগের জন্য প্রয়োজনীয় তথ্য'
    },
    {
      title: 'আইনি ডকুমেন্ট',
      description: 'ট্রেড লাইসেন্স ও অন্যান্য কাগজপত্র'
    },
    {
      title: 'ব্যাংক তথ্য',
      description: 'পেমেন্টের জন্য ব্যাংক অ্যাকাউন্ট তথ্য'
    }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleNext = () => {
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => {
    setActiveStep(prev => prev - 1);
  };

  const handleSubmit = () => {
    // Handle form submission
    console.log('Form submitted:', formData);
    setRegistrationOpen(false);
    setActiveStep(0);
  };

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>বিজনেস অ্যাকাউন্ট</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  বিজনেস অ্যাকাউন্ট
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto', mb: 4 }}>
                  আপনার ব্যবসাকে নিয়ে যান নতুন উচ্চতায় - গ্রামীণ বাজারের বিজনেস অ্যাকাউন্টের সাথে
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => setRegistrationOpen(true)}
                  sx={{
                    bgcolor: 'white',
                    color: 'primary.main',
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    '&:hover': {
                      bgcolor: 'grey.100'
                    }
                  }}
                >
                  এখনই রেজিস্ট্রেশন করুন
                </Button>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Business Benefits */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              ব্যবসায়িক সুবিধাসমূহ
            </Typography>
            <Grid container spacing={2.5} sx={{ px: 2 }}>
              {businessBenefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} md={4} key={index} sx={{ mb: 2 }}>
                  <Slide direction="up" in timeout={800 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0',
                        borderRadius: 2,
                        mx: 1,
                        mt: 1
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: benefit.color,
                          width: 64,
                          height: 64,
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        {benefit.icon}
                      </Avatar>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 1.5 }}>
                        {benefit.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, flexGrow: 1 }}>
                        {benefit.description}
                      </Typography>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Account Types */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              অ্যাকাউন্টের ধরন
            </Typography>
            <Grid container spacing={4}>
              {accountTypes.map((account, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Fade in timeout={1200 + index * 200}>
                    <Card
                      sx={{
                        p: 3,
                        height: '100%',
                        border: account.recommended ? `2px solid ${account.color}` : '1px solid #e2e8f0',
                        borderRadius: 2,
                        position: 'relative',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        }
                      }}
                    >
                      {account.recommended && (
                        <Chip
                          label="সুপারিশকৃত"
                          color="primary"
                          sx={{
                            position: 'absolute',
                            top: -10,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontWeight: 600
                          }}
                        />
                      )}
                      <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: account.color }}>
                          {account.type}
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                          {account.price}
                        </Typography>
                      </Box>
                      <List>
                        {account.features.map((feature, featureIndex) => (
                          <ListItem key={featureIndex} sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <CheckCircleIcon sx={{ color: account.color, fontSize: 20 }} />
                            </ListItemIcon>
                            <ListItemText 
                              primary={feature} 
                              sx={{ '& .MuiListItemText-primary': { fontSize: '0.9rem' } }}
                            />
                          </ListItem>
                        ))}
                      </List>
                      <Button
                        variant={account.recommended ? "contained" : "outlined"}
                        fullWidth
                        sx={{ mt: 2 }}
                        onClick={() => {
                          setFormData(prev => ({ ...prev, accountType: account.type.toLowerCase() }));
                          setRegistrationOpen(true);
                        }}
                      >
                        {account.type === 'এন্টারপ্রাইজ' ? 'যোগাযোগ করুন' : 'শুরু করুন'}
                      </Button>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Features */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              বিশেষ ফিচারসমূহ
            </Typography>
            <Grid container spacing={4}>
              {features.map((feature, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Fade in timeout={1400 + index * 200}>
                    <Card
                      sx={{
                        p: 3,
                        height: '100%',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Avatar sx={{ bgcolor: '#667eea', mr: 2 }}>
                          {feature.icon}
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {feature.category}
                        </Typography>
                      </Box>
                      <List>
                        {feature.items.map((item, itemIndex) => (
                          <ListItem key={itemIndex} sx={{ py: 0.5, pl: 0 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <CheckCircleIcon sx={{ color: '#4CAF50', fontSize: 18 }} />
                            </ListItemIcon>
                            <ListItemText 
                              primary={item}
                              sx={{ '& .MuiListItemText-primary': { fontSize: '0.9rem' } }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Success Stories */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              সফলতার গল্প
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <Card sx={{ p: 3, textAlign: 'center', border: '1px solid #e2e8f0' }}>
                  <Avatar sx={{ bgcolor: '#4CAF50', width: 60, height: 60, mx: 'auto', mb: 2 }}>
                    <StoreIcon />
                  </Avatar>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    রহিম ট্রেডার্স
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    "গ্রামীণ বাজারের বিজনেস অ্যাকাউন্টের মাধ্যমে আমাদের বিক্রয় ৩০০% বৃদ্ধি পেয়েছে।"
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {[1,2,3,4,5].map((star) => (
                      <StarIcon key={star} sx={{ color: '#FFD700', fontSize: 20 }} />
                    ))}
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card sx={{ p: 3, textAlign: 'center', border: '1px solid #e2e8f0' }}>
                  <Avatar sx={{ bgcolor: '#2196F3', width: 60, height: 60, mx: 'auto', mb: 2 }}>
                    <AgricultureIcon />
                  </Avatar>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    সবুজ কৃষি ফার্ম
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    "সরাসরি ক্রেতাদের কাছে পৌঁছানোর মাধ্যমে আমাদের লাভ দ্বিগুণ হয়েছে।"
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {[1,2,3,4,5].map((star) => (
                      <StarIcon key={star} sx={{ color: '#FFD700', fontSize: 20 }} />
                    ))}
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card sx={{ p: 3, textAlign: 'center', border: '1px solid #e2e8f0' }}>
                  <Avatar sx={{ bgcolor: '#FF9800', width: 60, height: 60, mx: 'auto', mb: 2 }}>
                    <FactoryIcon />
                  </Avatar>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    ঢাকা গার্মেন্টস
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    "অনলাইন প্ল্যাটফর্মের মাধ্যমে আমরা দেশব্যাপী গ্রাহক পেয়েছি।"
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {[1,2,3,4,5].map((star) => (
                      <StarIcon key={star} sx={{ color: '#FFD700', fontSize: 20 }} />
                    ))}
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Call to Action */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3,
              mt: '80px'
            }}
          >
            <BusinessIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              আজই শুরু করুন আপনার ব্যবসায়িক যাত্রা
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, maxWidth: '600px', mx: 'auto' }}>
              গ্রামীণ বাজারের বিজনেস অ্যাকাউন্টের সাথে আপনার ব্যবসাকে নিয়ে যান নতুন উচ্চতায়
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => setRegistrationOpen(true)}
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                রেজিস্ট্রেশন করুন
              </Button>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  border: '2px solid white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                যোগাযোগ করুন
              </MuiLink>
            </Box>
          </Paper>
        </Container>

        {/* Registration Dialog */}
        <Dialog 
          open={registrationOpen} 
          onClose={() => setRegistrationOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              বিজনেস অ্যাকাউন্ট রেজিস্ট্রেশন
            </Typography>
            <Button onClick={() => setRegistrationOpen(false)}>
              <CloseIcon />
            </Button>
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={activeStep} orientation="vertical">
              {registrationSteps.map((step, index) => (
                <Step key={index}>
                  <StepLabel>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {step.title}
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
                      {step.description}
                    </Typography>
                    
                    {index === 0 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="ব্যবসার নাম"
                            value={formData.businessName}
                            onChange={(e) => handleInputChange('businessName', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl fullWidth required>
                            <InputLabel>ব্যবসার ধরন</InputLabel>
                            <Select
                              value={formData.businessType}
                              onChange={(e) => handleInputChange('businessType', e.target.value)}
                              label="ব্যবসার ধরন"
                            >
                              {businessTypes.map((type) => (
                                <MenuItem key={type.value} value={type.value}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {type.icon}
                                    {type.label}
                                  </Box>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    )}

                    {index === 1 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="যোগাযোগকারীর নাম"
                            value={formData.contactPerson}
                            onChange={(e) => handleInputChange('contactPerson', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="ইমেইল"
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="ফোন নম্বর"
                            value={formData.phone}
                            onChange={(e) => handleInputChange('phone', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="ঠিকানা"
                            multiline
                            rows={3}
                            value={formData.address}
                            onChange={(e) => handleInputChange('address', e.target.value)}
                            required
                          />
                        </Grid>
                      </Grid>
                    )}

                    {index === 2 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="ট্রেড লাইসেন্স নম্বর"
                            value={formData.tradeLicense}
                            onChange={(e) => handleInputChange('tradeLicense', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="TIN নম্বর"
                            value={formData.tinNumber}
                            onChange={(e) => handleInputChange('tinNumber', e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<UploadIcon />}
                            fullWidth
                          >
                            ট্রেড লাইসেন্স আপলোড করুন
                            <input type="file" hidden accept=".pdf,.jpg,.png" />
                          </Button>
                        </Grid>
                      </Grid>
                    )}

                    {index === 3 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="ব্যাংক অ্যাকাউন্ট নম্বর"
                            value={formData.bankAccount}
                            onChange={(e) => handleInputChange('bankAccount', e.target.value)}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={<Checkbox />}
                            label="আমি শর্তাবলী ও নীতিমালার সাথে একমত"
                          />
                        </Grid>
                      </Grid>
                    )}

                    <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                      >
                        পূর্ববর্তী
                      </Button>
                      <Button
                        variant="contained"
                        onClick={activeStep === registrationSteps.length - 1 ? handleSubmit : handleNext}
                      >
                        {activeStep === registrationSteps.length - 1 ? 'সাবমিট করুন' : 'পরবর্তী'}
                      </Button>
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </DialogContent>
        </Dialog>
      </Box>
      <Footer />
    </>
  );
};

export default BusinessAccount; 